import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root'
})
export class SecureStorageService {

    // ❗ DO NOT hardcode in real production
    // Ideally inject from environment + rotate via backend
    private SECRET_KEY = 'EVENT_APP@2025#SECURE';

    setSession(key: string, value: any): void {
        const encrypted = CryptoJS.AES.encrypt(
            JSON.stringify(value),
            this.SECRET_KEY
        ).toString();

        sessionStorage.setItem(key, encrypted);
    }

    getSession<T>(key: string): T | null {
        const encrypted = sessionStorage.getItem(key);
        if (!encrypted) return null;

        try {
            const bytes = CryptoJS.AES.decrypt(encrypted, this.SECRET_KEY);
            const decrypted = bytes.toString(CryptoJS.enc.Utf8);
            return JSON.parse(decrypted);
        } catch (e) {
            console.error('Session decrypt failed', e);
            return null;
        }
    }

    removeSession(key: string): void {
        sessionStorage.removeItem(key);
    }

    clearSession(): void {
        sessionStorage.clear();
    }
}
